import React from "react";
const Progress=(props)=>{
    return(
        <>
        <div class="lang" >
        <p className="langpp">{props.prog} : </p>
        <div class="progress">
          <div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar"
          data-aos="fade-right"

            aria-valuenow={props.perc} aria-valuemin="0" aria-valuemax="100" style={{ width: props.perc+"%" }}>
            {props.perc}%
        
</div>
</div>
</div>
</>
    );
}
export default Progress;